/**
 * Exporting route paths here instead of via ./routes.ts to avoid circular imports,
 * which can happen when a settings file imports from ./routes.ts
 */
export const projectDashboardRoutePath = "/rhumbix/company-admin/projects"
export const projectConfigDashboardRoutePath = "/rhumbix/company-admin/project-config"
export const projectDashboardAddNewRoutePath = `${projectDashboardRoutePath}/new`
export const projectDashboardUploadRoutePath = `${projectDashboardRoutePath}/upload`
export const picklistDashboardRoutePath = "/rhumbix/company-admin/picklists"
